import { AllSelection } from '@tiptap/pm/state';
import { INDENT_TYPE } from 'ricos-content';
import type { EditorPlugin } from 'ricos-types';
import { isTextSelection } from 'wix-rich-content-editor-common';

import { pluginBlockquote } from './blockquote/blockquote';
import { pluginBold } from './bold/bold';
import { pluginBreakout } from './breakout/breakout';
import { pluginBulletedList } from './bulleted-list/bulleted-list';
import { pluginDraggable } from './draggable/draggable';
import { pluginFontSize } from './font-size/font-size';
import { pluginHardBreak } from './hard-break/hard-break';
import { pluginItalic } from './italic/italic';
import { pluginListItem } from './list-item/list-item';
import { pluginNotOvertypable } from './not-overwritable/not-overtypable';
import { pluginOrderedList } from './ordered-list/ordered-list';
import { pluginParagraph } from './paragraph/paragraph';
import { pluginResizable } from './resizable/resizable';
import { pluginSelection } from './selection/selection';
import { pluginTab } from './tab/tab';
import { pluginTextAlignment } from './text-align/text-align';
import { pluginTitle } from './title/title';
import { pluginUnderline } from './underline/underline';
import { pluginUndoRedo } from './undo-redo/undo-redo';

export type {} from './blockquote/extension';
export type {} from './bold/extension';
export type {} from './breakout/extension';
export type {} from './bulleted-list/extension';
export type {} from './draggable/extension';
export type {} from './font-size/extension';
export type {} from './hard-break/extension';
export type {} from './italic/extension';
export type {} from './list-item/extension';
export type {} from './ordered-list/extension';
export type {} from './paragraph/extension';
export type {} from './resizable/extension';
export type {} from './selection/extension';
export type {} from './tab/extension';
export type {} from './text-align/extension';
export type {} from './title/extension';
export type {} from './underline/extension';
export type {} from './undo-redo/history';

export const commonPlugins = [
  pluginBlockquote,
  pluginBold,
  pluginBulletedList,
  pluginFontSize,
  pluginItalic,
  pluginListItem,
  pluginOrderedList,
  pluginParagraph,
  pluginTextAlignment,
  pluginUnderline,
  pluginResizable,
  pluginDraggable,
  pluginUndoRedo,
  pluginTitle,
  pluginHardBreak,
  pluginBreakout,
  pluginTab,
  pluginSelection,
  pluginNotOvertypable,
] as EditorPlugin<Record<string, any>>[];

export const commonPluginConfig = {
  [INDENT_TYPE]: { isTextSelection, AllSelection },
};
